import { render, staticRenderFns } from "./ErrorMobile.vue?vue&type=template&id=4966d1ae&scoped=true&"
import script from "./ErrorMobile.vue?vue&type=script&lang=js&"
export * from "./ErrorMobile.vue?vue&type=script&lang=js&"
import style0 from "./ErrorMobile.vue?vue&type=style&index=0&id=4966d1ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4966d1ae",
  null
  
)

export default component.exports